/**
 * API Client Configuration
 *
 * Configures the generated OpenAPI client with the correct base URL
 * from environment variables and JWT authentication.
 */
import { OpenAPI } from '../generated';

// Get API URL from environment
// Remove /api suffix since the generated client already includes it in endpoints
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const BASE_URL = API_URL.replace('/api', '');

// Configure the OpenAPI client
OpenAPI.BASE = BASE_URL;
OpenAPI.WITH_CREDENTIALS = false;
OpenAPI.CREDENTIALS = 'include';

// Token will be set by Auth0 interceptor in the app initialization
// This is a reference that can be updated
let accessTokenGetter: (() => Promise<string>) | null = null;

/**
 * Set the function to get the access token
 * This should be called during app initialization with Auth0's getAccessTokenSilently
 */
export const setAccessTokenGetter = (getter: () => Promise<string>) => {
  accessTokenGetter = getter;
};

/**
 * Configure OpenAPI client to include JWT token in all requests
 */
OpenAPI.TOKEN = async () => {
  if (accessTokenGetter) {
    try {
      const token = await accessTokenGetter();
      return token;
    } catch (error) {
      console.error('Failed to get access token:', error);
      return '';
    }
  }
  return '';
};

// Helper to get the full URL for static files (images, etc.)
export const getStaticFileUrl = (path: string | null): string | null => {
  if (!path) return null;
  // If path is already a full URL, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Otherwise, prepend the base URL
  return `${BASE_URL}${path}`;
};

// Export for debugging
export const API_CONFIG = {
  BASE_URL,
  API_URL: process.env.REACT_APP_API_URL,
};

console.log('🔧 API Client configured:', API_CONFIG);
